import React, { Component } from 'react'
import s from './styles.scss'
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import moment from 'moment'
import { keyBy } from 'lodash'

const SESSION = `
  id
  _id
  state
  number
  date
  state
  time_begin
  time_end
  time_begin_forced
  time_end_forced
  payments {
    id
    _id
    amount_tutor
    amount_parent
    amount_sofia
    discount_tutor
    discount_parent
  }
`

const QUERY = gql`
query Request($uuid: String) {
  subjects {
    id
    _id
    name
  }
  request(_id: $uuid) {
    id
    _id
    state
    started
    start_date
    nbr_sessions
    nbr_sessions_week
    tutor_price
    parent_price
    sofia_price
    address
    precision_location
    avaibilitys {
      id
      day
      start
      end
    }
    sessions {
      ${SESSION}
    }
    request_students {
      id
      subjects_uuids
      student {
        id
        _id
        first_name
        last_name
        sublevel
        level {
          id
          _id
          name
        }
      }
    }
    tutor {
      id
      _id
      user {
        id
        _id
        first_name
        last_name
      }
    }
  }
}
`

const ADD_SESSION = gql`
  mutation($input: sessionMutation) {
    addSession(input: $input) {
      ${SESSION}
    }
  }
`

const STOP_SESSION = gql`
mutation stopSession($input: sessionMutation!) {
  stopSession(input: $input) {
    ${SESSION}
  }
}
`

const UPDATE_SESSION = gql`
mutation updateSession($input: sessionMutation) {
  updateSession(input: $input) {
    ${SESSION}
  }
}
`

const dayToString = day => {
  switch (parseInt(day, 10)) {
    case 0:
      return "Sunday"
    case 1:
      return "Monday"
    case 2:
      return "Tuesday"
    case 3:
      return "Wednesday"
    case 4:
      return "Thursday"
    case 5:
      return "Friday"
    case 6:
      return "Saturday"
    default:
      return "Invalid"
  }
}

class RequestDetails extends Component {

  state = {}

  constructor(props) {
    super(props);
    this.number = React.createRef();
    this.state = React.createRef();
    this.date = React.createRef();
    this.time_begin = React.createRef();
    this.time_end = React.createRef();
  }

  render() {

    if (!this.props.uuid) return null

    return <Query
      query={QUERY}
      variables={{
        uuid: this.props.uuid
      }}
      >
      {({ loading, error, data, fetchMore }) => {
      if (loading) return null;
      if (error) {
        console.error(error)
        return <p>Error :(</p>
      };

      const { 
        id, 
        _id,
        sessions,
        tutor_price,
        parent_price,
        sofia_price,
        avaibilitys,
        start_date,
        nbr_sessions,
        nbr_sessions_week,
        request_students,
        address,
        precision_location,
      } = data.request

      const lastSession = sessions.length ? sessions[sessions.length - 1] : {}
      const subjectsByUuid = keyBy(data.subjects, '_id')
   
      return <div className={s.container}>

        <div className={s.sessionList}>
          {sessions.map(({ id, _id, number, date, state, time_begin, time_end, time_begin_forced, time_end_forced, payments }, key) => {
            return <div className="box">
            
              <div className="split">

                <div className="mr">
                  <label>Numéro de séance</label>
                  <Mutation mutation={UPDATE_SESSION}>
                    {(updateSession, { data }) => (
                        <input type="text" className="small" defaultValue={number} placeholder="Time begin" onBlur={e => updateSession({ variables: { input: { _id, number: e.target.value } } })} />
                    )}
                  </Mutation>
                </div>

                <div>
                  <label>État</label>
                  <Mutation mutation={UPDATE_SESSION}>
                    {(updateSession, { data }) => (<React.Fragment>
                        <select className="small" defaultValue={state} onChange={e => updateSession({ variables: { input: { _id, state: e.target.value } } })}>
                          <option value="AVENIR">AVENIR</option>
                          <option value="TERMINEE-ET-A-PAYER">TERMINEE-ET-A-PAYER</option>
                          <option value="TERMINEE-ET-PAYEE">TERMINEE-ET-PAYEE</option>
                          <option value="ANNULEE">ANNULEE</option>
                        </select>
                    </React.Fragment>)}
                  </Mutation>
                </div>

              </div>
              
              
              
                <label>Date de la séance</label>
                <Mutation mutation={UPDATE_SESSION}>
                  {(updateSession, { data }) => (
                      <input type="date" className="small" defaultValue={moment(date).format("YYYY-MM-DD")} placeholder="Date" onBlur={e => {
                        let date = moment(e.target.value)
                        date = date.utcOffset(0)
                        date = date.toISOString()
                        updateSession({ variables: { input: { _id, date } } })
                      }}
                      disabled={state === "ANNULEE"} />
                  )}
                </Mutation>

              {state !== 'ANNULEE' && <React.Fragment>
                <div className="split">

                    <div className="mr">
                      <label>Heure de début</label>
                      <Mutation mutation={UPDATE_SESSION}>
                        {(updateSession, { data }) => (
                            <input type="text" className="small" defaultValue={time_begin} placeholder="Time begin" onBlur={e => updateSession({ variables: { input: { _id, time_begin: e.target.value } } })} disabled={state === "TERMINEE-ET-PAYEE"} />
                        )}
                      </Mutation>
                    </div>

                    <div>
                      <label>Heure de fin</label>
                      <Mutation mutation={UPDATE_SESSION}>
                        {(updateSession, { data }) => (
                            <input type="text" className="small" defaultValue={time_end} placeholder="Time end" onBlur={e => updateSession({ variables: { input: { _id, time_end: e.target.value } } })} disabled={state === "TERMINEE-ET-PAYEE"} />
                        )}
                      </Mutation>
                    </div>

                </div>

                <div className="split">

                    <div className="mr">
                      <label>Heure début réelle</label>
                      <Mutation mutation={UPDATE_SESSION}>
                        {(updateSession, { data }) => (
                            <input type="text" className="small" defaultValue={time_begin_forced} placeholder="Time begin forced" onBlur={e => updateSession({ variables: { input: { _id, time_begin_forced: e.target.value } } })} disabled={state === "TERMINEE-ET-PAYEE"} />
                        )}
                      </Mutation>
                    </div>

                    <div>
                      <label>Heure de fin réelle</label>
                      <Mutation mutation={UPDATE_SESSION}>
                        {(updateSession, { data }) => (
                            <input type="text" className="small" defaultValue={time_end_forced} placeholder="Time end forced" onBlur={e => updateSession({ variables: { input: { _id, time_end_forced: e.target.value } } })} disabled={state === "TERMINEE-ET-PAYEE"} />
                        )}
                      </Mutation>
                    </div>

                </div>

              </React.Fragment>}

              {state === "TERMINEE-ET-A-PAYER" && <Mutation mutation={STOP_SESSION}>
                {(stopSession, { data }) => (
                    <div>
                      <button onClick={() => {
                        stopSession({
                          variables: {
                            input: {
                              _id,
                              time_begin_forced,
                              time_end_forced
                            }
                          }
                        })
                      }}>Payer</button>
                    </div>
                )}
              </Mutation>}

              {state === "TERMINEE-ET-PAYEE" && payments[0] && <div>
                  <br />
                <b>Parent:</b> {payments[0].amount_parent}$<br />
                <b>Tuteur:</b> {payments[0].amount_tutor}$<br />
                <b>Sofia:</b> {payments[0].amount_sofia}$<br />
              </div>}

              <div>
                <br/> <small><i>{id} - {_id}</i></small>
              </div>
            </div>
          })}


          <Mutation
            mutation={ADD_SESSION}
            update={(cache, { data: { addSession } }) => {
              const { request } = cache.readQuery({ query: QUERY, variables: { uuid: this.props.uuid } });
              cache.writeQuery({
                query: QUERY,
                data: { request: {
                  ...request,
                  sessions: [...request.sessions, addSession]
                }}
              });
            }}
          >
            {addSession => <div className="box">

              <form onSubmit={e => {
                e.preventDefault()
                addSession({
                  variables: {
                    input: {
                      number: this.number.current.value,
                      state: this.state.current.value,
                      date: moment(this.date.value).format("YYYY-MM-DD"),
                      time_begin: this.time_begin.current.value,
                      time_end: this.time_end.current.value,
                      request_uuid: _id,
                      request_id: id
                    }
                  }
                })
              }}>
                <h2>Ajouter une séance</h2>

                <div className="split">
                  <div className="mr">
                    <label>Numéro de séance</label>
                    <input name="number" type="text" className="small" value={lastSession.number + 1 || 1} placeholder="1" ref={this.number}  />
                  </div>
                  <div>
                    <label>État</label>
                    <select name="state" className="small" defaultValue="AVENIR" ref={this.state}>
                      <option value="AVENIR">AVENIR</option>
                      <option value="TERMINEE-ET-A-PAYER">TERMINEE-ET-A-PAYER</option>
                      <option value="TERMINEE-ET-PAYEE">TERMINEE-ET-PAYEE</option>
                      <option value="ANNULEE">ANNULEE</option>
                    </select>
                  </div>
                </div>

                <label>Date de la séance</label>
                <input name="date" type="date" className="small" defaultValue={moment(lastSession.date).add(7, 'days').format("YYYY-MM-DD")} placeholder="Date" ref={this.date}  />
                  
                <div className="split">
                    <div className="mr">
                      <label>Heure de début</label>
                      <input name="time_begin" type="text" className="small" defaultValue={lastSession.time_begin || ''} placeholder="Time begin" ref={this.time_begin} />
                    </div>
                    <div>
                      <label>Heure de fin</label>
                      <input name="time_end" type="text" className="small" defaultValue={lastSession.time_end || ''} placeholder="Time end" ref={this.time_end} />
                    </div>
                </div>
                
                <p>
                  <button type="submit">Ajouter</button>
                </p>
                
              </form>

            </div>}
          </Mutation>
        </div>

        <div className={s.sessionDetails}>
          <div className="box inline">
            <h3>Students</h3>
            {request_students.map(({ student, subjects_uuids }, key) => <div key={key}>
              <h4>{student.first_name}</h4>
              <small>{student.level.name} • {student.sublevel}</small>

              {subjects_uuids.map((_id) => <div key={_id}>{subjectsByUuid[_id].name}</div>)}

            </div>)}
          </div>

          <div className="box">
            <h3>Avaibilities</h3>
            {avaibilitys.map(({ day, start, end }) => <div>
              <b>{dayToString(day)}</b> {start.replace(/:00$/, '')} - {end.replace(/:00$/, '')}
            </div>)}
          </div>
         

          <div className="box">
            <h3>Location</h3>
            <b>{address}</b><br/>
            {precision_location}
          </div>

          <div className="box">
            <b>Nbr sessions: </b> {nbr_sessions} <br/>
            <b>Nbr sessions / week: </b> {nbr_sessions_week} <br/>
            <b>Start date: </b> {moment(start_date).format("DD/MM/YYYY")} <br/>
          </div>

          <div className="box">
            <h3>Prix</h3>
            <b>Tuteur: </b> {tutor_price} <br/>
            <b>Parent: </b> {parent_price} <br/>
            <b>Sofia: </b> {sofia_price}
          </div>
        </div>
      </div>

      }}
  </Query>
  }
}

export default RequestDetails;



// WEBPACK FOOTER //
// ./src/containers/requests/Details/tabs/sessions.js